import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { ImageStyled } from './styles';
import { ImageProps } from './types';

const Image: React.FC<ImageProps> = ({ image, objectFit, objectPosition, loading, alt }) => {
  const imageFluid = getImage(image);

  return (
    <ImageStyled>
      {imageFluid && (
        <GatsbyImage
          image={imageFluid}
          objectFit={objectFit || 'cover'}
          objectPosition={objectPosition || '50% 50%'}
          style={{ height: '100%', width: '100%' }}
          loading={loading || 'lazy'}
          {...{ alt }}
        />
      )}
    </ImageStyled>
  );
};

export default Image;
